import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLast3Months } from "../../utils/getLast3Months";
import { ApiHook } from "../../hooks/apiHook";
import { ProgressBar } from "react-bootstrap";
import { getLast2Years } from "../../utils/getLast2years";
import Skeleton from "react-loading-skeleton";
import IncentivesSkeleton from "./IncentivesSkeleton";
import { months } from "../../utils/months";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { useParams } from "react-router";

const GemBonusCom = () => {
  const params = useParams();
  const [selectedMonth, setSelectedMonth] = useState(
    getLast3Months()?.[0].fullDate
  );
  const [userId, setUserId] = useState(params.id);
  const { t } = useTranslation();
  const data = ApiHook.CallGemBonus(selectedMonth, userId);
  const [showSupervisorModal, setShowSupervisorModal] = useState(false);
  const [showLeaderModal, setShowLeaderModal] = useState(false);

  const handleMonthChange = (month) => setSelectedMonth(month);

  const handleSupervisorClick = () => {
    setShowSupervisorModal(true);
  };

  const closeSupervisorModal = () => {
    setShowSupervisorModal(false);
  };

  const handleLeaderClick = () => {
    setShowLeaderModal(true);
  };

  const closeLeaderModal = () => {
    setShowLeaderModal(false);
  };
  /**
   * Helper to render a progress bar with required values
   */
  const renderProgressBar = (item, index, levelIndex) => {
    if (!data?.data?.level?.[levelIndex]) return "N/A";

    const level = data.data.level[levelIndex];
    const required =
      index === 0
        ? level.monthThreeLess
        : index === 1
        ? level.monthTwo
        : index === 2
        ? level.monthOne
        : null;

    if (!required) return "N/A";

    return (
      <>
        <ProgressBar
          variant="success"
          now={item.totalPv ?? 0}
          max={required}
          label={`${item.totalPv ?? 0} / ${required}`}
        />
        <span className="required-text">
          {required} {t("required") || t("Required")}
        </span>
      </>
    );
  };

  const generalRenderProgressBar = (required, current) => {
    if (required == null || isNaN(required)) return "N/A";

    const currentValue = parseFloat(current) || 0;
    const requiredValue = parseFloat(required) || 0;

    return (
      <>
        <ProgressBar
          variant="success"
          now={currentValue}
          max={requiredValue}
          label={`${currentValue} / ${requiredValue}`}
        />
        <span className="required-text">
          {requiredValue} {t("required") || t("Required")}
        </span>
      </>
    );
  };
  const renderIcons = (renderCondition) => {
    if (renderCondition == null) return null;

    return renderCondition ? (
      <i
        className="fa fa-check-circle"
        style={{
          color: "green",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    ) : (
      <i
        className="fa fa-times-circle"
        style={{
          color: "red",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    );
  };

  const countIndicator = (required, current) => {
    if (required == null || current == null) return "N/A";

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "flex-start",
          }}
        >
          {/* Row of boxes */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[...Array(required)].map((_, idx) => (
              <div
                key={idx}
                style={{
                  height: "20px",
                  width: "20px",
                  border: "1px solid green",
                  backgroundColor: current > idx ? "green" : "transparent",
                }}
              />
            ))}
          </div>

          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              alignContent: "center",
            }}
          >
            {required}
          </span>
        </div>
      </>
    );
  };

  const isUserQualified = () => {
    if (!data?.data) return false;

    const { months, summary, config } = data.data;

    // Check all qualification criteria
    const isActiveEveryMonth = months?.every((obj) => obj.activeStatus);
    const hasEnoughTotalPv = summary?.totalPv >= config?.total_cc;
    const hasEnoughNewPv = summary?.totalNewCC >= config?.new_cc;
    const hasEnoughSupervisors =
      summary?.superVisors >= config?.supervisor_lines;

    // User is qualified only if ALL conditions are met
    return (
      isActiveEveryMonth &&
      hasEnoughTotalPv &&
      hasEnoughNewPv &&
      hasEnoughSupervisors
    );
  };
  if (data.isLoading) {
    return <IncentivesSkeleton />;
  }
  const qualified = isUserQualified();

  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end "></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            <h6 className="table-heading-incentives">{t("GemBonus")}</h6>
            <div className="row incentives-subheading justify-content-between">
                  <span>Name : {data?.data?.fullName}</span>
                <span>User Name : {data?.data?.username}</span>
            </div>
            <div className="table-container">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <h5>{t("Leadership Bonus Qualified")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("Required")}: {t("Current month")}{" "}
                        {renderIcons(
                          Number(data?.data?.data?.leaderShipQulified),
                          1
                        )}
                      </p>
                    </td>
                    <td colSpan={10}>
                      {data?.data?.data?.leaderShipQulified ? "YES" : "NO"}
                    </td>
                  </tr>

                  <tr>
                    <th style={{ textAlign: "center" }}></th>
                    <th style={{ textAlign: "center" }}>{t("Level 1")}</th>
                    <th style={{ textAlign: "center" }}>{t("Level 2")}</th>
                    <th style={{ textAlign: "center" }}>{t("Level 3")}</th>
                  </tr>
                  <tr>
                    <td>
                      <div>
                        ({t("1st Gen Active Leaders")})
                        <span
                          onClick={
                            data?.data?.data?.firstGenerationActiveManagerLines
                              ?.count > 0
                              ? handleLeaderClick
                              : undefined
                          }
                          style={{
                            cursor:
                              data?.data?.data
                                ?.firstGenerationActiveManagerLines?.count > 0
                                ? "pointer"
                                : "default",
                            color:
                              data?.data?.data
                                ?.firstGenerationActiveManagerLines?.count > 0
                                ? "#007bff"
                                : "#333",
                            textDecoration:
                              data?.data?.data
                                ?.firstGenerationActiveManagerLines?.count > 0
                                ? "underline"
                                : "none",
                            position: "relative",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={
                            data?.data?.data?.firstGenerationActiveManagerLines
                              ?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor = "#f8f9fa";
                                }
                              : undefined
                          }
                          onMouseLeave={
                            data?.data?.data?.firstGenerationActiveManagerLines
                              ?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }
                              : undefined
                          }
                        >
                         ( {t("You Have")} ) :{" "}
                          {data?.data?.data?.firstGenerationActiveManagerLines
                            ?.count || 0}
                        </span>
                      </div>
                    </td>
                    {data?.data?.data?.configs?.map((config, index) => (
                      <td key={index} style={{ textAlign: "center" }}>
                        <ProgressBar
                          now={parseFloat(
                            data?.data?.data?.firstGenerationActiveManagerLines
                              ?.count ?? 0
                          )}
                          max={parseFloat(config.first_generation ?? 0)}
                          label={`${parseFloat(
                            data?.data?.data?.firstGenerationActiveManagerLines
                              ?.count ?? 0
                          )} / ${parseFloat(config.first_generation ?? 0)}`}
                          variant="success"
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {config.first_generation} {t("Required")}
                      </td>
                    ))}
                  </tr>
                  <div style={{ padding: "10px" }}>{t("OR")}</div>

                  <tr>
                    <td>
                      <div>
                           {t("25 KC Active Leaders Lines")}
                        <span
                          onClick={
                            data?.data?.data?.activeLeaderLines.count > 0
                              ? handleSupervisorClick
                              : undefined
                          }
                          style={{
                            cursor:
                              data?.data?.data?.activeLeaderLines.count > 0
                                ? "pointer"
                                : "default",
                            color:
                              data?.data?.data?.activeLeaderLines.count > 0
                                ? "#007bff"
                                : "#333",
                            textDecoration:
                              data?.data?.data?.activeLeaderLines.count > 0
                                ? "underline"
                                : "none",
                            position: "relative",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={
                            data?.data?.data?.activeLeaderLines.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor = "#f8f9fa";
                                }
                              : undefined
                          }
                          onMouseLeave={
                            data?.data?.data?.activeLeaderLines.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }
                              : undefined
                          }
                        >
                          ({t("You Have")}:{" "}
                          {data?.data?.data?.activeLeaderLines.count || 0})
                        </span>
                      </div>
                    </td>
                    {data?.data?.data?.configs?.map((config, index) => (
                      <td key={index} style={{ textAlign: "center" }}>
                        <ProgressBar
                          now={parseFloat(
                            data?.data?.data?.activeLeaderLines.count ?? 0
                          )}
                          max={parseFloat(config.downline_manager_count ?? 0)}
                          label={`${parseFloat(
                            data?.data?.data?.activeLeaderLines.count ?? 0
                          )} / ${parseFloat(
                            config.downline_manager_count ?? 0
                          )}`}
                          variant="success"
                          style={{ minHeight: "25px", fontSize: "12px" }}
                        />
                        {config.downline_manager_count || 0} {t("Required")}
                      </td>
                    ))}
                  </tr>
                  <div style={{ padding: "10px" }}>{t("OR")}</div>
                  <tr>
                    <td>
                      <div>{t("EagleManagerLevel")}</div>
                    </td>
                    {data?.data?.data?.configs?.map((config, index) => (
                      <td key={index} style={{ textAlign: "center" }}>
                        {data?.data?.data?.eagleManagerLevel &&
                        data?.data?.data?.eagleManagerLevel.gem_config_id ==
                          config.id ? (
                          <i
                            className="fa fa-check-circle"
                            style={{ fontSize: "12px", color: "green" }}
                          ></i>
                        ) : (
                          <i
                            className="fa fa-times-circle"
                            style={{ fontSize: "12px", color: "red" }}
                          ></i>
                        )}
                        <p>{config.name || 0}</p>
                      </td>
                    ))}
                  </tr>

                  {/* {data?.data?.userPoints?.map((item, index) => (
                    <tr key={index}>
                      <td colSpan={2}>{item.monthName}</td>
                      <td colSpan={2}>{item.downlineLeaderCount ?? 0}</td>
                      <td colSpan={2}>{item.totalPv ?? "N/A"}</td>
                      <td colSpan={2}>{renderProgressBar(item, index, 0)}</td>
                      <td colSpan={2}>{renderProgressBar(item, index, 1)}</td>
                      <td colSpan={2}>{renderProgressBar(item, index, 2)}</td>
                    </tr>
                  ))} */}
                </tbody>
              </table>

              {/* ===== Month Tabs ===== */}
              <div className="month-tabs">
                {getLast3Months().map((month) => (
                  <button
                    key={month.fullDate}
                    className={`month-tab ${
                      selectedMonth === month.fullDate ? "active" : ""
                    }`}
                    onClick={() => handleMonthChange(month.fullDate)}
                  >
                    {month.value}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={showSupervisorModal}
          onHide={closeSupervisorModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa fa-users me-2"></i>
              Active Leader Lines (
              {data?.data?.data?.activeLeaderLines?.count || 0} Total)
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {data?.data?.data?.activeLeaderLines &&
            data?.data?.data?.activeLeaderLines?.count > 0 ? (
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Leg Name</th>
                    <th>User Name</th>
                    <th>Total KC</th>
                    <th>Generation</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.data?.activeLeaderLines?.downlines?.map(
                    (supervisor, index) => (
                      <tr key={supervisor.id || index}>
                        <td>{index + 1}</td>
                        <td>{supervisor.legName || "N/A"}</td>
                        <td>{supervisor.LeaderLines[0]?.User?.username}</td>
                        <td>{supervisor.LeaderLines[0]?.totalPv}</td>
                        <td>
                          {parseInt(
                            supervisor.LeaderLines[0]?.User?.userLevel
                          ) - parseInt(supervisor.UserLevel) || "N/A"}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            ) : (
              <div className="text-center py-4">
                <i className="fa fa-users fa-3x text-muted mb-3"></i>
                <p className="text-muted">No supervisor details available</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-between w-100">
              {/* <div>
                      <small className="text-muted">
                        Total Supervisors:{" "}
                        <strong>{data?.data?.summary?.superVisors || 0}</strong> |
                        Required:{" "}
                        <strong>{data?.data?.config?.supervisor_lines || 0}</strong>
                      </small>
                    </div> */}
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeSupervisorModal}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showLeaderModal}
          onHide={closeLeaderModal}
          size="lg"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fa fa-users me-2"></i>
              Active Leader Lines (
              {data?.data?.data?.firstGenerationActiveManagerLines?.count ||
                0}{" "}
              Total)
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {data?.data?.data?.firstGenerationActiveManagerLines &&
            data?.data?.data?.firstGenerationActiveManagerLines?.count > 0 ? (
              <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Leg Name</th>
                    <th>User Name</th>
                    <th>Generation</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.data?.activeLeaderLines?.downlines?.map(
                    (supervisor, index) => (
                      <tr key={supervisor.id || index}>
                        <td>{index + 1}</td>
                        <td>{supervisor.legName || "N/A"}</td>
                        <td>{supervisor.LeaderLines[0]?.User?.username}</td>
                        <td>
                          {Number(supervisor.LeaderLines[0]?.User?.userLevel) -
                            Number(supervisor.UserLevel) || "N/A"}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </Table>
            ) : (
              <div className="text-center py-4">
                <i className="fa fa-users fa-3x text-muted mb-3"></i>
                <p className="text-muted">No supervisor details available</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="d-flex justify-content-between w-100">
              {/* <div>
                      <small className="text-muted">
                        Total Supervisors:{" "}
                        <strong>{data?.data?.summary?.superVisors || 0}</strong> |
                        Required:{" "}
                        <strong>{data?.data?.config?.supervisor_lines || 0}</strong>
                      </small>
                    </div> */}
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeLeaderModal}
              >
                Close
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};

export default GemBonusCom;
